// extracted by mini-css-extract-plugin
export var ctaButton = "freeTerminalCta-module--ctaButton--dx453";
export var readerImg = "freeTerminalCta-module--readerImg--Z0+7D";
export var root = "freeTerminalCta-module--root--ZzxVs";